/* =========================

  which is name

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";

// Retina用imgタグ
import ImageRetina from "../../../Components/Part/ImageRetina";

/* -------------------------

  component

---------------------------- */
function Finish( props ) {

  return (
    <Styled>
      <div className="p-keyvisual">
        <section className="p-keyvisual__section--title p-keyvisual__section">
          <div className="p-keyvisual__section__inner l-inner--1100">

            {/* コンテンツ */}
            <div className="p-keyvisual__section__conts p-keyvisual__layer_02">

              <div className="p-keyvisual__block--title p-keyvisual__block">
                {/* h1タイトル */}
                <div className="p-keyvisual__box--h1 p-keyvisual__box c-font_f--km">
                  <h1 className="title">
                    <span className="title__first_row"><span>お</span><span>悩</span><span>み</span><span>別</span></span><br /><span className="title__second_row">アイテム診断</span>
                  </h1>
                </div>
                {/* h1タイトル */}

                {/* 画像 */}
                <div className="p-keyvisual__box--img p-keyvisual__box sp_only">
                  <ImageRetina
                    type={"png"}
                    src_pc_1x={"/assets/img/top/p-keyvisual/sp/keyvisual-img01.png"}
                    src_pc_2x={"/assets/img/top/p-keyvisual/sp/keyvisual-img01@2x.png"}
                    alt={""}
                  />
                </div>
                {/* 画像 */}

                {/* テキスト */}
                <div className="p-keyvisual__box--txt p-keyvisual__box">
                  <p className="txt">5つの簡単な質問に答えるだけ！<br />あなたのお悩みに合わせた商品をご案内します。</p>
                </div>
                {/* テキスト */}

                {/* ボタン */}
                <div className="p-keyvisual__box--btn p-keyvisual__box">
                  <p className="txt c-font_f--km pc_only">＼ 全<span>5</span>問：所要時間<span>1</span>分 ／</p>
                  {props.children}
                </div>
                {/* ボタン */}

              </div>
            </div>
            {/* コンテンツ */}

            {/* 背景 */}
            <div className="p-keyvisual__section__bg p-keyvisual__layer_01 pc_only">
              <div className="p-keyvisual__block--bg p-keyvisual__block">
                <div className="p-keyvisual__box--bg p-keyvisual__box">
                  <div className="img_territory_01 img_territory">
                    <ImageRetina
                      type={"png"}
                      src_pc_1x={"/assets/img/top/p-keyvisual/keyvisual-img01.png"}
                      src_pc_2x={"/assets/img/top/p-keyvisual/keyvisual-img01@2x.png"}
                      alt={""}
                    />
                  </div>

                  <div className="img_territory_02 img_territory">
                  <ImageRetina
                      type={"png"}
                      src_pc_1x={"/assets/img/top/p-keyvisual/keyvisual-img02.png"}
                      src_pc_2x={"/assets/img/top/p-keyvisual/keyvisual-img02@2x.png"}
                      alt={""}
                    />
                  </div>

                </div>
              </div>
            </div>
            {/* 背景 */}
          </div>
        </section>
      </div>
    </Styled>
  );
}

export default Finish;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.div`
  .p-keyvisual {
    color: #451700;
    margin: 40px 0 40px 0;
    .p-keyvisual__section--title {
      position: relative;
      width: fit-content;
      margin: auto;
      padding: 9px 0 0 0;
      &::before {
        position: absolute;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
        content: "";
        display: block;
        width: 250px;
        height: 26px;
        background-color: #d1bb80;
      }
      .p-keyvisual__section__inner {
        overflow: hidden;
        position: relative;
        padding: 40px 0 50px 0;
        background-color: #ffffff;
        border: 8px solid #d1bb80;
        border-radius: 20px;
      }
      .p-keyvisual__layer_02 {
        z-index: 2;
      }
      .p-keyvisual__layer_01 {
        z-index: 1;
      }
      .p-keyvisual__section__conts {
        position: relative;
        .p-keyvisual__block--title {
          .p-keyvisual__box--h1 {
            width: fit-content;
            margin: auto;
            .title {
              position: relative;
              text-align: center;
              &::after {
                position: absolute;
                right: -80px;
                bottom: 0;
                z-index: 2;
                content: "";
                display: block;
                width: 77px;
                height: 78px;
                background-image: url(${process.env.PUBLIC_URL}/assets/img/top/p-keyvisual/keyvisual-img04.png);
                background-size: 100% auto;
              }
              .title__first_row {
                color: #ffffff;
                font-size: 5.8rem;
                line-height: 1;
                span {
                  display: inline-block;
                  width: 1.5em;
                  height: 1.5em;
                  border-radius: 10px;
                  background-color: #74482d;
                  text-align: center;
                  line-height: 1.4em;
                  & + span {
                    margin-left: 10px;
                  }
                }
              }
              .title__second_row {
                font-size: 8.2rem;
                line-height: 1;
              }
            }
          }
          .p-keyvisual__box--txt {
            margin-top: 30px;
            font-size: 1.7rem;
            font-weight: bold;
            text-align: center;
          }
          .p-keyvisual__box--btn {
            .txt {
              font-size: 2.6rem;
              font-weight: bold;
              text-align: center;
              span {
                font-size: 3.8rem;
              }
            }
            .c-btn_start {
              margin: auto;
            }
          }
        }
      }
      .p-keyvisual__section__bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        .p-keyvisual__block--bg {
          height: 100%;
          .p-keyvisual__box--bg {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            height: 100%;
            .img_territory {
                width: auto;
                height: 100%;
              img {
                width: auto;
                height: 100%;
              }
            }
            .img_territory_01 {
              display: flex;
              align-items: flex-end;
            }
            .img_territory_02 {
              display: flex;
              align-items: center;
              margin-right: 70px;
            }
          }
        }
      }
    }
  }

	@media ${break_point_sp} {
    .p-keyvisual {
      margin: 5% 3%;
      .p-keyvisual__section--title {
        padding: 0;
        &::before {
          content: none;
        }
        .p-keyvisual__section__inner {
          padding: 5%;
        }
        .p-keyvisual__section__conts {
          .p-keyvisual__block--title {
            .p-keyvisual__box--h1 {
              .title {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                &::before {
                  position: absolute;
                  left: -110px;
                  bottom: 0;
                  z-index: 2;
                  content: "";
                  display: block;
                  width: 108px;
                  height: 109px;
                  background-image: url(${process.env.PUBLIC_URL}/assets/img/top/p-keyvisual/keyvisual-img03.png);
                  background-size: 100% auto;
                }
                &::before {
                  position: relative;
                  left: auto;
                  bottom: auto;
                  display: inline-block;
                  width: calc(130 / 750 * 100vw);
                  height: calc(130 / 750 * 100vw);
                }
                &::after {
                  position: relative;
                  right: auto;
                  bottom: auto;
                  display: inline-block;
                  width: calc(100 / 750 * 100vw);
                  height: calc(100 / 750 * 100vw);
                }
                .title__first_row {
                  font-size: calc(65 / 750 * 100vw);
                  span {
                    & + span {
                      margin-left: 5px;
                    }
                  }
                }
                .title__second_row {
                  font-size: calc(83 / 750 * 100vw);
                }
              }
            }
            .p-keyvisual__box--img {
              width: 70%;
              margin: 7% auto auto auto;
            }
            .p-keyvisual__box--txt {
              font-size: calc(27 / 750 * 100vw);
            }
          }
        }
      }
    }
	}
`;
